import React from 'react'
import {FieldGuesser, ShowGuesser} from '@api-platform/admin'
import {TextField, NumberField, ReferenceField, BooleanField} from 'react-admin';
import {useTranslation} from "react-i18next";

function Show(props) {
    const {t} = useTranslation()
    return (
        <ShowGuesser {...props}>
            <TextField source="originId" label={t('id')}/>
            <TextField source="name" label={t('common.name')}/>
            <ReferenceField source="pool" reference="dictionary/pool_companies" link={false} label={t('brief.pool')}
                            sortable={false}>
                <TextField source="name"/>
            </ReferenceField>
            <NumberField source="mpmId" label={'mpmId'}/>
            <BooleanField source="isBriefManyProducts" label={t('admin.isBriefManyProducts')}/>
            <BooleanField source="isBriefManyChannels" label={t('admin.isBriefManyChannels')}/>
        </ShowGuesser>
    )
}

export default Show
